module.exports = __webpack_public_path__ + "img/colaboration-of-catalunya-film-festival.bdbf1932.png";